import React from 'react';
import '../primitives/Button.css';
import '../primitives/Stack.css';
import '../../theme/semantic.css';
import './AppShell.css';
import '../../styles/auth-desktop-interactions.css';

export function AppShell({ header, sidebar, children }) {
  return (
    <div className="app-shell">
      <div className="app-shell__body">
        {sidebar && <aside className="app-shell__sidebar">{sidebar}</aside>}
        <main className="app-shell__main">{children}</main>
      </div>
    </div>
  );
}

export default AppShell;